//Assessments modules
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import { useMemo } from "react"
import { Dropdown } from "primereact/dropdown"

export default function FormulaBuilderMatrixQuestions({
  questionLabels,
  selectedIndex,
  onSelectedIndexChanged,
}) {
  const questionLabel = useMemo(() => {
    return questionLabels.map((label, index) => {
      return {
        value: index,
        label: label.text,
      }
    })
  }, [questionLabels])

  return (
    <>
      <FormulaBuilderGroupingPanel title="Matrix questions">
        Select which matrix question you want to build a formula for.
      </FormulaBuilderGroupingPanel>

      <div className={myStyles.operatorContainer}>
        <Dropdown
          value={selectedIndex}
          options={questionLabel}
          onChange={(e) => onSelectedIndexChanged(e.value)}
          optionLabel="label"
          className={myStyles.matrixQuestionLabelDropDown}
        />
      </div>
    </>
  )
}
